import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n                        Confirm Employee Details\n                    ")
], -1);
const _hoisted_5 = { class: "mt-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "sapNumber",
    class: "block text-sm font-medium text-gray-700"
}, "Employee SAP Number *", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_9 = ["disabled"];
import { toRef } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmSapDetails',
    props: {
        disableForm: { type: Boolean },
        formData: {},
        document: {}
    },
    emits: ["update:formData", "submit-form", "complete-offer"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = toRef(props, 'formData');
        const handleInput = (event) => {
            const target = event.target;
            const { name, value } = target;
            model.value[name] = value;
            emit('update:formData', { formName: 'sap', formData: model.value });
        };
        const submitForm = async () => {
            emit('submit-form', { name: 'sap', data: model.value });
        };
        const handleConfirm = async () => {
            emit('submit-form', { name: 'sap', data: model.value, completed: true });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: props.formData?.sapNumber,
                                    type: "text",
                                    name: "sapNumber",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: props.disableForm,
                                    onInput: handleInput
                                }, null, 40, _hoisted_7)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (!_ctx.disableForm && _ctx.document.currentStageName === 'offer.notifyOfferSent')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _withModifiers(submitForm, ["prevent"])
                            }, "\n                    Save\n                "),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "ml-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                disabled: !props.formData?.saved,
                                onClick: _withModifiers(handleConfirm, ["prevent"])
                            }, "\n                    Confirm\n                ", 8, _hoisted_9)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
